const ignoredWebsocketNotReadyMessage =
  'websocket send error: websocket not ready';

function containsIgnoredWebsocketNotReadyMessage(value: unknown): boolean {
  if (typeof value !== 'string') {
    return false;
  }

  return value.toLowerCase().includes(ignoredWebsocketNotReadyMessage);
}

export function shouldFilterWebsocketNotReadySentryLog(log: {
  message?: unknown;
}): boolean {
  return containsIgnoredWebsocketNotReadyMessage(log.message);
}

export function shouldFilterWebsocketNotReadySentryEvent(event: {
  message?: unknown;
  logentry?: { message?: unknown };
  exception?: { values?: { value?: unknown }[] };
}): boolean {
  return (
    containsIgnoredWebsocketNotReadyMessage(event.message) ||
    containsIgnoredWebsocketNotReadyMessage(event.logentry?.message) ||
    event.exception?.values?.some((value) =>
      containsIgnoredWebsocketNotReadyMessage(value?.value),
    ) === true
  );
}
